import { createScenario } from '@funtech-int/rival';
import { lazy } from '@funtech-int/rival-react';

import { RouteSkeleton } from '@/shared/components/PageSpinner/PageSpinner';

import { mainRoute } from './routes';

const scenario = createScenario((ctx) => {
    ctx.addRoute({
        route: mainRoute,
        meta: {
            plusPaymentPage: 'MyMoviesScreen',
            page: 'main',
        },
        component: lazy(() => import('./components/Home/Home')),
        fallback: RouteSkeleton,
    });
});

export * from './routes';

export default scenario;
